import { NUM_CATEGORIES } from '@mc/constants'
import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { CORE_MEMBERSHIP_LANGUAGE_CLEANUP_I18N_NAMESPACE } from '../i18n'
import { useLanguageCleanupEV } from './useLanguageCleanupEV'
import { useLanguageCleanupExperiment } from './useLanguageCleanupExperiment'

export const useGetAllClasses = () => {
  const { isVariant } = useLanguageCleanupExperiment()
  const { t } = useTranslation(CORE_MEMBERSHIP_LANGUAGE_CLEANUP_I18N_NAMESPACE)

  useLanguageCleanupEV()

  if (!isVariant) return null

  return t('nav.callout.subtitle', {
    instructors: getNumberOfInstructors(),
    categories: NUM_CATEGORIES,
  })
}
